module.exports = __webpack_public_path__ + "static/media/404.85064a97.svg";